const SOUND_SRC = '/media/notify.mp3';
const UNLOCK_EVENTS = ['touchend', 'click', 'keydown'];

let audio = null;
let unlocked = false;
let listenersBound = false;

const getAudio = () => {
  if (!audio) {
    audio = new Audio(SOUND_SRC);
    audio.volume = 0.5;
    audio.preload = 'auto';
  }
  return audio;
};

const removeUnlockListeners = () => {
  if (!listenersBound) return;
  UNLOCK_EVENTS.forEach((eventName) => {
    document.removeEventListener(eventName, unlockHandler, true);
  });
  listenersBound = false;
};

function unlockHandler() {
  if (unlocked) {
    removeUnlockListeners();
    return;
  }
  const el = getAudio();
  const finalize = () => {
    el.pause();
    try {
      el.currentTime = 0;
    } catch (e) {
      // noop
    }
    unlocked = true;
    removeUnlockListeners();
  };
  const playPromise = el.play();
  el.pause();
  if (playPromise && typeof playPromise.then === 'function') {
    playPromise.then(finalize).catch((error) => {
      if (error && error.name === 'NotAllowedError') return;
      finalize();
    });
  } else {
    finalize();
  }
}

export const initSoundNotification = () => {
  if (unlocked || listenersBound) return;
  getAudio();
  UNLOCK_EVENTS.forEach((eventName) => {
    document.addEventListener(eventName, unlockHandler, true);
  });
  listenersBound = true;
};

export const playSoundNotification = () => {
  const el = getAudio();
  try {
    el.currentTime = 0;
  } catch (e) {
    // noop
  }
  const playPromise = el.play();
  if (playPromise && typeof playPromise.catch === 'function') {
    playPromise.catch(() => {});
  }
};
